module.exports = __webpack_public_path__ + "img/team_5.17311829.png";